const URL_LINKEDIN_PROFILE_PREFIX: string = 'https://www.linkedin.com/';

export default URL_LINKEDIN_PROFILE_PREFIX;
